<template>
  <div>
    <p>{{message}}</p>
    <EmailFormInput />
    <p>To be able to start an investigation we'll need 2 photos. Please upload them here</p>
    <input type="file" name="photo1" id="photo1" :required="required">
    <input type="file" name="photo2" id="photo2">
    <SubmitButton btnText="Submit Enquiry" />
  </div>
</template>

<script>
import EmailFormInput from '../components/EmailFormInput'
import SubmitButton from '../components/SubmitButton'

export default {
  props: ['message', 'required'],
  components: {
    EmailFormInput,
    SubmitButton
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DamagedForm.vue